import React, { FunctionComponent, useCallback, useEffect } from "react";
import useSelection from "@/use-selection";
import useSelectionEffects from "@/use-selection-effects";
import Service from "components/page/detail/service";
import useKeyPress from "@/use-key-press";
import useGtagEffects from "@/use-gtag-effects";
import useIndicationEffects from "@/use-indication-effects";

const Detail: FunctionComponent<DetailProps> = () => {
  const { ampolService } = useSelection();
  const { setSelection } = useSelectionEffects();
  const { setIndication } = useIndicationEffects();

  useKeyPress("Escape", "keydown", () => setSelection(null));

  const { triggerEvent } = useGtagEffects();

  useEffect(() => {
    if (ampolService != null) {
      triggerEvent("view_item", {
        items: [
          {
            item_id: ampolService?.$id,
            item_name: ampolService?.name,
            item_category: ampolService?.services?.includes("WOWDiscounts")
              ? "WOWDiscounts"
              : undefined,
          },
        ],
      });
    }
  }, [ampolService, triggerEvent]);

  useEffect(() => {
    triggerEvent("screen_view", { screen_name: "detail" });
  }, [triggerEvent]);

  const onCloseHandler = useCallback(() => {
    setSelection(null);
    if (ampolService != null) {
      setIndication(null);
    }
  }, [setIndication, setSelection, ampolService]);

  if (ampolService == null) {
    return null;
  }

  return (
    <>
      <div className="tw-min-w-80 tw-max-w-96 tw-m-auto 2xl:!tw-m-0 @4xl/main:!tw-m-0 tw-h-full tw-pointer-events-auto tw-flex-col">
        <div>
          <Service ampolService={ampolService} onClose={onCloseHandler} />
        </div>
      </div>
    </>
  );
};

export type DetailProps = {};

export default React.memo(Detail);
